import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7df29e04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-sort flex-ter" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "sort-btn flex-col"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "flex-cen-ter productTagClass"
}
const _hoisted_9 = {
  key: 0,
  class: "flex-ter"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://static-jp.theckb.com/static-asset/client/tag.png" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("商品のみ表示")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "flex-ter"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("전시만 ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://static-s.theckb.com/BusinessMarket/icon/1688selected/only_select_ko.png" }, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("상품")
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 2,
  class: "flex-ter"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://static-s.theckb.com/BusinessMarket/Client/good-selected-price-en.png" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { key: 3 }
const _hoisted_22 = {
  key: 1,
  class: "flex-cen-ter productTagClass"
}

import { toRef, computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { t } from '@/plugins/i18n'
import { isJA, useSite } from '@/store'
import { keywordList } from '@/views/product/CreateAssociated/components/CommonProduct/useCommonProduct'
interface S {
  label: string
  bothway: boolean
  name: string,
  showInImageSearch: boolean
}

export default /*#__PURE__*/_defineComponent({
  props: ['params', 'showCkbDiscount', 'supplierRespDTO'],
  setup(__props) {

const props = __props
const site = useSite()
const store = useStore()
const route = useRoute()
const router = useRouter()

const params = toRef(props, 'params')

const sortTypes = ref<S[]>([...store.state.bussiness.SortTypes])

const showKo = computed(() => ['1688 선별', '1688严选', '1688 Sourcing'].includes(route.query.keyword as string))

watch(() => route.query, (val) => {
  // 国家货盘
  if (((isJA() && route.query.platformType === 'AM' && !route.query.imageId && !route.query.productCode) && ((!keywordList.includes(route.query.keyword as string)) || route.query.national === '1')) || (isJA() && route.query.platformType === 'AM' && route.query.productCategoryFrontendId)) {
    if (sortTypes.value.findIndex(i => i.name === 're_purchase') === -1) {
      sortTypes.value.push({
        label: t('复购率'),
        bothway: false,
        name: 're_purchase',
        showInImageSearch: false
      })
    }
  } else {
    sortTypes.value = sortTypes.value.filter(i => i.name !== 're_purchase')
  }
  console.log(sortTypes.value, 'sortTypes.value')
}, {
  immediate: true
})

/** 切换折扣精选 */
const changeCheck = (value: any) => { change({ isCkbDiscount: value ? '1' : '0' }) }
/** 切换一件代发 */
const changeOnePsale = (value: any) => { change({ isOnePsale: value }) }

const sort = ({ name, bothway }: S, order: boolean | void) => {
  if (typeof order === 'boolean') {
    change({
      sortType: name,
      descendOrder: order
    })
  } else {
    if (name === params.value.sortType) {
      change({
        descendOrder: bothway ? !params.value.descendOrder : true
      })
    } else {
      change({
        sortType: name,
        descendOrder: !bothway
      })
    }
  }
}
/** 切换参数 */
const change = (v: any) => {
  const query = {
    ...route.query,
    ...v
  }
  router.replace({ ...route, query })
}

/** 精选折扣是否选择上 */
const checked = computed(() => {
  return params.value.isCkbDiscount === '1'
})
/** 一件代发是否选择上 */
const isOnePsale = computed(() => {
  return params.value.isOnePsale === 'true'
})

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortTypes.value, (v) => {
      return (_openBlock(), _createElementBlock("div", {
        key: v.label,
        class: "flex-ter sort-item"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex-ter sort-item-content", { active: _unref(params).sortType === v.name }])
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["btn label", { active: _unref(params).sortType === v.name }]),
            onClick: ($event: any) => (sort(v))
          }, _toDisplayString(v.label), 11, _hoisted_2),
          (v.bothway)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_unref(params).sortType === v.name && !_unref(params).descendOrder)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: _normalizeClass(["fa fa-caret-up btn", {
              active: _unref(params).sortType === v.name && !_unref(params).descendOrder
            }]),
                      onClick: ($event: any) => (sort(v, false))
                    }, null, 10, _hoisted_4))
                  : _createCommentVNode("", true),
                (_unref(params).sortType === v.name && _unref(params).descendOrder)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 1,
                      class: _normalizeClass(["fa fa-caret-down btn", { active: _unref(params).sortType === v.name && _unref(params).descendOrder }]),
                      onClick: ($event: any) => (sort(v, true))
                    }, null, 10, _hoisted_5))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (v.name === 'product_sell_price')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["sort-pop", _unref(useSite)()])
              }, [
                _createElementVNode("div", {
                  onClick: ($event: any) => (sort(v, false)),
                  class: _normalizeClass({
              active: _unref(params).sortType === v.name && !_unref(params).descendOrder
            })
                }, _toDisplayString(_unref(t)('价格从低到高')), 11, _hoisted_6),
                _createElementVNode("div", {
                  onClick: ($event: any) => (sort(v, true)),
                  class: _normalizeClass({ active: _unref(params).sortType === v.name && _unref(params).descendOrder })
                }, _toDisplayString(_unref(t)('价格从高到低')), 11, _hoisted_7)
              ], 2))
            : _createCommentVNode("", true)
        ], 2)
      ]))
    }), 128)),
    (__props.showCkbDiscount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_el_checkbox, {
            modelValue: _unref(checked),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(checked) ? (checked).value = $event : null)),
            onChange: changeCheck
          }, {
            default: _withCtx(() => [
              (_unref(site) === 'ja')
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_12))
                : _createCommentVNode("", true),
              (_unref(site) === 'ko')
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _hoisted_17))
                : _createCommentVNode("", true),
              (_unref(site) === 'en')
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _hoisted_20))
                : _createCommentVNode("", true),
              (_unref(site) === 'zh')
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "只看精选会员折扣价"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    ((!_unref(route).query.schannel || _unref(route).query.schannel === '2') && (!_unref(route).query.platformType || _unref(route).query.platformType === 'AM'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          (!(_unref(route).query.shopCode && __props.supplierRespDTO?.platformType !== 'AM'))
            ? (_openBlock(), _createBlock(_component_el_checkbox, {
                key: 0,
                modelValue: _unref(isOnePsale),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(isOnePsale) ? (isOnePsale).value = $event : null)),
                onChange: changeOnePsale
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('支持一件代发')), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})